<template>
  <label class="flex items-center" :class="{ 'opacity-60': disabled }">
    <input
      v-model="valueLocal"
      type="checkbox"
      class="local-checkmark-default ring-0 ring-offset-0"
      :class="{ '': disabled }"
      :value="checkboxValue"
      :disabled="disabled"
    />
    <slot></slot>
  </label>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  modelValue?: boolean | any[];
  checkboxValue?: number | null;
  disabled?: boolean;
}
interface Emits {
  (e: 'update:modelValue' | 'change', data: Props['modelValue']): void;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  checkboxValue: null,
  disabled: false,
});

const emit = defineEmits<Emits>();

const valueLocal = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    if (props.disabled) return;
    emit('update:modelValue', newValue);
    emit('change', newValue);
  },
});
</script>
